// 接口平台
export default {
  
  // 淘宝换货单接口-拒绝换货
  TAOBOREFUSEEXCHANGE: {
    component: () => import(
      /* webpackChunkName: 'InterfaceCenterModal' */
      '@/views/modal/interfacePlatform/taobaoRefuseExchange.vue'
    )
  },
  // 淘宝订单接口 - 动作定义 （列表-批量处理异常按钮）
   TAOBAO_ORDER_HANDLE: {
    component: () => import('@/views/modal/interfacePlatform/taobaoOrderHandle.vue')
  },
};
